import { useMutation } from "react-query"

import reservationsService from "api/reservationsService"

const useSetVehicleKeyStatus = () => {
  return useMutation(async (reservationId: number) => {
    try {
      const res = await reservationsService.setVehicleKeyStatus(reservationId)

      return res.data
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  })
}

export default useSetVehicleKeyStatus
